import React, { ReactNode } from "react";

import { Typography } from "@mui/material";

import { ReactComponent as WarningIcon } from "assets/images/warning-icon.svg";

import "./index.scss";

interface WarningBoxProps {
  title?: string;
  content: ReactNode;
}

const WarningBox: React.FC<WarningBoxProps> = ({ title, content }) => {
  return (
    <div className="warning-box">
      <div className="warning-icon">
        <WarningIcon />
      </div>
      <div className="warning-box-content">
        <Typography variant="subtitle2" color="warning.dark" sx={{ mb: 0.5 }}>
          {title || "Зверніть увагу!"}
        </Typography>
        <Typography variant="body2">{content}</Typography>
      </div>
    </div>
  );
};

export default WarningBox;
